<template>
  <div>
    <el-form label-width="170px" class="xzformitemmb">
      <el-row>
        <panel title="放款信息" border>
          <el-col :span="12">
            <el-form-item label="流水号 ：">
              {{payPledgeFinancingData.pay__reference}}
            </el-form-item>
            <el-form-item label="放款方式 ：">
              {{payPledgeFinancingData.pay__channel|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款状态 ：">
               {{"Pay_"+payPledgeFinancingData.fi__transactionStatus|Status2CN}}
            </el-form-item>
            <el-form-item label="放款金额 ：">
              {{payPledgeFinancingData.pay__totalAmount|formatMoney}} 元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款时间 ：">
              {{payPledgeFinancingData.pay__payDate|moment('YYYY-MM-DD hh:mm')}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="放款人 ：">
              {{payPledgeFinancingData.pay__cashier == 'SYSTEM' ? '自动放款' : payPledgeFinancingData.pay__cashier}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="放款账户 ：">
              {{payPledgeFinancingData.payBA__bank+"-"+payPledgeFinancingData.payBA__accountName+"-"+payPledgeFinancingData.payBA__accountNo}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收款账户 ：">
              {{payPledgeFinancingData.loanBA__bank+"-"+payPledgeFinancingData.loanBA__accountName+"-"+payPledgeFinancingData.loanBA__accountNo}}
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
    <panel title="还款信息" border>
      <data-table
        :columns="columns"
        :page-size="100"
        :table-data="repaymentList"
        :is-pagination-show="false"
        @doRepay = 'doRepay'
      />
    </panel>
  </div>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import FormBuild from '../../components/FormBuild'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN"
  import {formatMoney} from "../../filters/CommonFilters";

  export default {
    name: "RepayDetailDataTable",
    data() {
      return {
        dialogVisible: false,
      }
    },
    components: {
      DataTable,
      FormBuild
    },
    props: {
      isCanRepay: {
        type: Boolean,
        default: true,
      },
      repaymentList: {
        type: Object,
        default: ()=>{
          return {
            data: [],
            count: 0
          }
        }
      },
      payPledgeFinancingData:{
        type: Object,
        default:()=>{
          return {}
        }
      },
      columns2: {
        type: Array,
        default: ()=>{

        }
      }
    },
    computed: {
      columns() {
        return [
          {
            label: '流水号',
            field: 're__reference'
          },
          {
            label: '还款方式',
            field: 're__channel',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '交易时间',
            field: 're__repayDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '还款金额',
            field: 're__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '还款账户',
            field: 'cj__outboundAccountDesc'
          },
          {
            label: '收款账户',
            field: 'cj__inboundAccountDesc'
          },
          {
            label: '备注',
            field: 're__remarks'
          }
        ]
      }
    },
    methods: {
      doRepay: function (index, row) {
        this.$emit('doRepay', index, row)
      }
    },
    filters:{
      Status2CN
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/RepayDetailDataTable.vue